import React from "react"
import { Link, graphql, useStaticQuery } from "gatsby"
import { AnchorLink } from "gatsby-plugin-anchor-links"

import meImg from "../img/me.png"
// import './header.module.scss'
import headerStyle from "./header.module.scss"

const Header = () => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)
  return (
    <header className={headerStyle.header}>
      <nav className={headerStyle.navWrapper}>
        {/* <Link to="/"> */}
        <a className={headerStyle.logo}>
          <Link
            className={headerStyle.navItem}
            activeClassName={headerStyle.activeNavItem}
            to="/"
          >
            <img className={headerStyle.meImg} src={meImg} />
          </Link>
        </a>
        {/* </Link> */}

        <ul className={headerStyle.navList}>
          <li>
            <Link
              className={headerStyle.navItem}
              activeClassName={headerStyle.activeNavItem}
              to="/"
            >
              HOME
            </Link>
          </li>
          <li>
            <AnchorLink
              className={headerStyle.navItem}
              activeClassName={headerStyle.activeNavItem}
              to="/#about"
            >
              ABOUT ME
            </AnchorLink>
          </li>
          {/* <li>
            <AnchorLink
              className={headerStyle.navItem}
              activeClassName={headerStyle.activeNavItem}
              to="/#experience"
            >
              EXPERIENCE
            </AnchorLink>
          </li> */}
          <li>
            <AnchorLink
              className={headerStyle.navItem}
              activeClassName={headerStyle.activeNavItem}
              to="/#projects"
            >
              PROJECTS
            </AnchorLink>
          </li>
          <li>
            <Link
              className={headerStyle.navItem}
              activeClassName={headerStyle.activeNavItem}
              to="/contact"
            >
              CONTACT
            </Link>
          </li>
        </ul>
      </nav>
    </header>
  )
}

export default Header
